import React, { useState } from 'react'
import StudentCourseService from '../../service/studentCourseService'
import CourseService from '../../service/courseService'
import useToken from '../../App/useToken'
import { useParams } from 'react-router-dom'
import { Button, Modal, Form, Col, Row } from 'react-bootstrap'
import spcs from '../../utils/Spc'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import './Order.css'

export default function Order({ courseId }) {
  // console.log('first', first)
  const { getToken } = useToken()
  const token = getToken()
  const { course_name, major_name } = useParams()
  const [spc, setSpc] = useState()

  const handleOnGeneratePmeReportOrder = async () => {
    const studentCourseService = new StudentCourseService()
    const res = await studentCourseService.generatePmeReportOrderByCourseName({
      course_name,
      token,
      spcNo: spc,
    })
    if (res.name) {
      const courseService = new CourseService()
      setTimeout(async () => {
        const dowloadLink = await courseService.dowloadFile('report', res.name)
        console.log('dowloadLink', dowloadLink)
        window.open(dowloadLink)
      }, 2000)
    }
    console.log('res :>> ', res)
  }

  return (
    <div className='main-container create-course container'>
      <Breadcrumb className='course-breadcrumb'>
        <Breadcrumb.Item href='/majorcourses'>Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/majorcourses/${major_name}`}>
          {major_name}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/majorcourses/${major_name}/course/${course_name}`}>
          {course_name}
        </Breadcrumb.Item>
        <Breadcrumb.Item active href='#'>
          ออกคำสั่ง
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className='request-order-container'>
        <Form className='form-request-order'>
          <Row>
            <Col md={4}>
              <Form.Group
                as={Col}
                onChange={(e) => {
                  setSpc(e.target.value)
                }}>
                <Form.Label>สายวิทยาการ :</Form.Label>
                <Form.Control as='select'>
                  <option value='0' selected='selected'>--เลือกสายวิทยาการ--</option>
                  {spcs.map((spc, index) => (
                    <option value={spc.no}>
                      {spc.no}. {spc.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md='12 submit-request-container'>
              <div className='btn-submit-request-order'>
                <Button
                  variant='primary'
                  onClick={handleOnGeneratePmeReportOrder}>
                  ออกคำสั่ง
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
        {/* <a onClick={handleOnGeneratePmeReportOrder}>ออกคำสั่ง</a> */}
      </div>
    </div>
  )
}
